import { useState, ReactNode } from 'react';
import styles from './index.module.scss';

export interface CouponPickerItem {
  id: number;
  title: string;
  description?: string;
  start_at?: string | null;
  expired_at?: string | null;
  picture_url?: string | null;
}

interface Props {
  coupons: CouponPickerItem[];
  onConfirm: (selectedIds: number[]) => void;
  confirmText?: string;
  emptyText?: string;
  // 預設日期（當 start_at / expired_at 為 null 時顯示）
  dueStart?: string;
  dueEnd?: string;
  footer?: ReactNode;
}

/**
 * 多選優惠券領取元件。
 * - 不限張數
 * - 以後端回傳的清單為準
 * - 可在會員歸還彈窗、momo 事後綁定領券區塊共用
 */
const CouponPicker = ({
  coupons,
  onConfirm,
  confirmText = '確定',
  emptyText = '優惠券已領取完畢',
  dueStart = '',
  dueEnd = '',
  footer,
}: Props) => {
  const [selected, setSelected] = useState<number[]>([]);

  const isEmpty = !coupons || coupons.length === 0;

  const toggle = (id: number) => {
    setSelected(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  const selectAll = () => {
    setSelected(coupons.map(c => c.id));
  };

  return (
    <div className={styles.couponPicker}>
      {isEmpty ? (
        <p className={styles.emptyText}>{emptyText}</p>
      ) : (
        <>
          <div className={styles.list}>
            {coupons.map(item => {
              const picked = selected.includes(item.id);
              return (
                <div className={styles.listItem} key={item.id}>
                  <div className={styles.coupon}>
                    <div className={styles.infoContainer}>
                      <span className={styles.title}>{item.title}</span>
                      <span className={styles.date}>
                        {item.start_at == null ? dueStart : item.start_at.slice(0, 10)}
                        ~
                        {item.expired_at == null ? dueEnd : item.expired_at.slice(0, 10)}
                      </span>
                    </div>
                    <div className={picked ? styles.btnContainerPicked : styles.btnContainer}>
                      <button type="button" onClick={() => toggle(item.id)}>
                        {picked ? '已選取' : '領取'}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className={styles.allContainer}>
            <button type="button" className={styles.allBtn} onClick={selectAll}>
              全部領取
            </button>
          </div>
        </>
      )}
      <div className={styles.footerWrap}>
        <button
          type="button"
          className={`${styles.btn} ${!isEmpty && selected.length === 0 ? styles.disabledBtn : ''}`}
          disabled={!isEmpty && selected.length === 0}
          onClick={() => onConfirm(isEmpty ? [] : selected)}
        >
          {confirmText}
        </button>
      </div>
      {footer}
    </div>
  );
};

export default CouponPicker;
